import { adminApiAxios } from '@/api'
import { clearUnitLocalStorage } from '@/features/banking/banking.constants'
import { clearPlaidConnectReminderSuppression } from '@/features/banking/plaid-connect-reminder'
import { assignLocation } from './browserNavigation'
import { resolveAdminReauthPath } from './adminContext'
import { logHeardError } from './errorHelpers'

export const performAdminLogout = async (): Promise<void> => {
  try {
    await adminApiAxios.post('/finances/api/v2/admin/logout')
  } catch (error) {
    // Still redirect so the admin lands off the app, but surface the failure:
    // a swallowed error here can mean the Stytch session was not revoked
    // server-side, leaving the admin authenticated despite the logout.
    logHeardError(error, { context: 'performAdminLogout' })
  }
  localStorage.removeItem('targetLink')
  clearUnitLocalStorage()
  clearPlaidConnectReminderSuppression()
  assignLocation(resolveAdminReauthPath())
}
